import React, { memo, FC, useCallback } from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { Icon } from '@surveycake/rc';
import { timesOutlined } from '@surveycake/rc';
import { useStyles } from './styles';

export interface SelectedItemProps {
  children: string;
  order: number;
  classes: ReturnType<typeof useStyles>;
  id: number;
  onRemove: (optionId: number) => void;
}

const SelectedItem: FC<SelectedItemProps> = ({
  children,
  order,
  classes,
  id,
  onRemove
}) => {
  const onClick = useCallback(() => onRemove(id), [onRemove, id]);
  return (
    <div className={classes.selectedItem}>
      <div>{order}</div>
      <div className={classes.selecetedItemText}>{children}</div>
      <span className={classes.selectedItemRemove} onClick={onClick}>
        <Icon icon={timesOutlined} />
      </span>
    </div>
  );
};

export default SortableElement(memo(SelectedItem));
